const CORE_RESOLVABLES = ['$stateParams', '$state$', '$transition$'];
const HOOK_OPTIONS = {
  priority: 1000
};
export async function waitForTransition(router, options) {
  const {
    transitionService,
    urlService
  } = router;
  const {
    to,
    resolvables,
    blacklist = []
  } = options;
  return new Promise((resolve, reject) => {
    const restoration = transitionService.onBefore({
      to
    }, handleRestore, HOOK_OPTIONS);
    const errorListener = transitionService.onError({}, handleError, HOOK_OPTIONS);
    const successListener = transitionService.onFinish({
      to
    }, handleResolve, HOOK_OPTIONS);
    urlService.sync();
    function handleError(transition) {
      const error = transition.error();

      // might be redirect to a new group slug
      if (!error.redirected) {
        cleanup();
        reject(error);
      }
    }
    async function handleResolve(transition) {
      if (options.disableWaitForResolvables) {
        cleanup();
        resolve({});
        return;
      }
      const tokens = transition.getResolveTokens().filter(token => typeof token === 'string' && !CORE_RESOLVABLES.includes(token));
      const resolvables = await Promise.all(tokens.map(async token => {
        const resolvable = await transition.injector().getAsync(token);
        return [token, resolvable];
      })).catch(() => []);
      cleanup();
      resolve(Object.fromEntries(resolvables));
    }
    function handleRestore(transition) {
      if (!resolvables) {
        return;
      }
      for (const node of transition.treeChanges().to) {
        for (const resolvable of node.resolvables) {
          if (blacklist.includes(resolvable.token) || !resolvables.hasOwnProperty(resolvable.token)) {
            continue;
          }
          resolvable.data = resolvables[resolvable.token];
          resolvable.resolved = true;
          resolvable.promise = Promise.resolve(resolvable.data);
        }
      }
    }
    function cleanup() {
      restoration();
      successListener();
      errorListener();
    }
  });
}
//# sourceMappingURL=transition.js.map